import { createClient } from '@supabase/supabase-js';
import { environment } from 'src/environments/environment';

export const backend = createClient(environment.backendUrl, environment.publicAnonKey);
